import React, { useState } from 'react'
import './NewSideBar.css'
import { AppstoreOutlined, LogoutOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import { IoIosHelpCircleOutline } from "react-icons/io";
import Logo from "../../assets/inner-logo.svg";
import Attendance from "../../assets/icons/attendance.svg";
import Employees from "../../assets/icons/employees.svg";
import Helpdesk from "../../assets/icons/helpdesk.svg";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUserInformation } from '../../store/slices/signUpSlice';
import { setDesig } from '../../store/slices/designationSlice';
import { setDept } from '../../store/slices/departmentSlice';
import { setLoc } from '../../store/slices/locationSlice';
import { setShft } from '../../store/slices/shiftSlice';
import ModalConfirm from '../../common/modalConfirm';
import { STAFF_ROLE } from '../../utils/constant';
function NewSideBar({ setAttendance=() => {},setSales=() => {},setCurrentstaff=() => {}}) {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.signUp.signUpDetails);

    const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};
    // const [active,setActive] = useState(savedState.active )
    const [active,setActive] = useState((savedState.active) || (userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.EmployeeHeads) && !userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.AttendanceHeads) ? 'emp' : 'atten'))
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const dispatch = useDispatch();
    const [modalVisible, setModalVisible] = useState(false);
    const shouldShowAttendance = userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.AttendanceHeads);
    const shouldShowEmployees = userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.EmployeeHeads);
    const handleOk = () => {
      logout()
      setModalVisible(false);
    };
  
    const handleCancel = () => {
      setModalVisible(false);
    };
    const logout = () => {
        localStorage.clear()
        sessionStorage.clear();
        dispatch(setUserInformation(''));
        dispatch(setDesig(''));
        dispatch(setDept(''));
        dispatch(setLoc(''));
        dispatch(setShft(''));
        navigate('/')
      };
    const {
        companyName = "",
        logo = "",
        firstName = "",
        lastName = "",
        email = "",
        phoneNumber = "",
        aadharNumber = "",
      } = useSelector((state) => state.signUp.signUpDetails);
      const click = (att) => {
          setAttendance(att)  
          setActive(savedState.att || att)
          setSales('')
          setCurrentstaff('')
          

        const stateToSave = {
          attendance:savedState.att ||att,
          salesDepartmentId:'',
          currentStaffId:'',
          click : att == 'emp'? '': savedState.click,
          empClick:att == 'atten'? '': savedState.empClick,
          sales:'',
          currentStaff:'' ,
          active:savedState.att || att

        };
        sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
         
        
     }
    return (
        <div className='newside-back'>
            <div className='flex justify-center mr-5 ml-5 main-praavi-tital'>
                <img src={Logo}/>
            </div>
            <div className='!mt-5 text-center text-white text-xl pt-2'>
                Welcome,<br/>
                {capitalizeFirstLetter(firstName)} {capitalizeFirstLetter(lastName)}
            </div>
            <div className='mt-10 nav-links text-white text-lg !px-4'>
            {(userInfo.userRole === "businessOwner" ||  userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.AttendanceHeads)) && (
  <div className={`flex items-center h-[62px] cursor-pointer mb-2 !px-4 ${active == 'atten' ? 'active rounded-[14px] !bg-white !bg-opacity-30 before:content-[""] before:w-[8px] before:bg-white before:block before:h-[62px] before:absolute before:-left-0 before:rounded-r-full' :''}`} onClick={() => click("atten")} value="atten">
                    <img src={Attendance} className='w-[18px] mr-3'/>
                    <span>Attendance</span>
                </div>
            )}
            {(userInfo.userRole === "businessOwner" || userInfo?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.EmployeeHeads)) && (
                <div className={`flex items-center h-[62px] cursor-pointer mb-2 !px-4  ${active == 'emp' ? 'active rounded-[14px] !bg-white !bg-opacity-30 before:content-[""] before:w-[8px] before:bg-white before:block before:h-[62px] before:absolute before:-left-0 before:rounded-r-full' :''}`} onClick={() => click("emp")} value="emp">
                    <img src={Employees} className='w-[25px] mr-3'/>
                    <span>Employees</span>
                </div>
               )}
                {/* <div className={`flex items-center h-[62px] cursor-pointer mb-2 !px-4  ${active == 'help' ? 'active rounded-[14px] !bg-white !bg-opacity-30 before:content-[""] before:w-[8px] before:bg-white before:block before:h-[62px] before:absolute before:-left-0 before:rounded-r-full' :''}`} onClick={() => click("help")} value="help">
                    <img src={Helpdesk} className='w-[24px] mr-3'/>
                    <span>Helpdesk</span>
                </div> */}
                <div onClick={() => setModalVisible(true)} className={`flex items-center h-[62px] cursor-pointer mb-2 !px-4`} >
                <LogoutOutlined className='w-[24px] mr-3'/>
                    <span >Logout</span>
                </div>
            </div>
            <div className='companyInfo'>
                        <div className='hr-profile'>
                        {userInfo?.userRole == "businessOwner" ?
                            <img className="hr-all-image" style={{ width: "50px", height: "50px",borderRadius:'50%' }} src={`${userInfo?.logo}?${new Date().getTime()}`}alt="" />
                            :
                            <img className="hr-all-image" style={{ width: "50px", height: "50px",borderRadius:'50%' }} src={userInfo?.boOwner?.logo} alt="" />
                        }
                            </div>
                        <div className='hr-name'>
                              {userInfo?.userRole == "businessOwner" ?
                            <p className='companyName' style={{ fontSize: '12px'}}>
                               {capitalizeFirstLetter(userInfo?.companyName)} 
                                 </p> :
                                 <p className='companyName'>
                                   {capitalizeFirstLetter(userInfo?.boOwner?.companyName)} 

                                 </p>
                                 }
                        </div>
                        
                    </div>
                    <ModalConfirm
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        title="Logout"
        content="Are you sure you want to logout?"
      />
        </div>
    )
}

export default NewSideBar